<template>
  <a-modal
    title="添加节"
    :visible="value"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
    :bodyStyle="{ paddingRight: '110px' }"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      layout="horizontal"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="名称" prop="name">
            <a-input v-model="form.name" placeholder="请输入章名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="描述" prop="description">
            <a-textarea v-model="form.description" placeholder="请输入描述" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="24">
          <a-form-model-item label="课时" prop="period">
            <a-input v-model="form.period" placeholder="请输入课时" />
          </a-form-model-item>
        </a-col> -->
        <a-col :span="12">
          <a-form-model-item
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
            label="讲师"
            prop="teacher"
          >
            <a-input v-model="form.teacher" placeholder="请输入讲师名称" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { addLesson, getLessonById, updateLesson } from '@/api/course/course'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    afterSubmit: {
      type: Function,
      default: function() {}
    },
    mode: {
      type: Object,
      default: () => ({
        type: 'add',
        sectionId: null,
        id: null
      })
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      confirmLoading: false,
      levels: ['新手入门', '高手进阶'],
      form: {
        name: undefined,
        description: undefined,
        // period: undefined,
        teacher: undefined
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'change'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'change'
          }
        ],
        // period: [
        //   {
        //     required: true,
        //     message: '请输入时长',
        //     trigger: 'change'
        //   }
        // ],
        teacher: [
          {
            required: false,
            message: '请输入讲师',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    mode(m) {
      if (m.type === 'update') {
        getLessonById(m.id).then(res => {
          let result = res.result
          Object.keys(this.form).forEach(key => {
            this.form[key] = result[key]
          })
        })
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { form, mode } = this
          this.confirmLoading = true
          const handler = () => {
            return Promise.resolve()
          }
          handler()
            .then(() => {
              if (mode.type === 'add') {
                return addLesson({ sectionId: mode.sectionId }, form)
              } else {
                return updateLesson(mode.id, form)
              }
            })
            .then(res => {
              const op = mode.type === 'add' ? '添加' : '修改'
              if (res.code === 200) {
                this.$notification['success']({
                  message: '成功',
                  description: `课程 ${form.name} ${op}成功`
                })
              }
              this.resetForm()
              this.$emit('input', false)
              this.afterSubmit && this.afterSubmit()
            })
            .finally(() => {
              this.confirmLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped></style>
